import { Component, ChangeDetectionStrategy, ViewChild, OnInit, AfterViewInit, NgZone, ChangeDetectorRef, OnDestroy, Inject, Optional, ElementRef } from '@angular/core';
import { isSameDay, isSameMonth, isAfter, startOfMonth, lastDayOfMonth } from 'date-fns';
import { Subject } from 'rxjs';
import { CalendarEvent, CalendarMonthViewComponent, CalendarView, CalendarWeekViewComponent } from 'angular-calendar';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { NavbarComponent } from '../../navbar/navbar.component';
import moment from 'moment';
import { RegularizationFormComponent } from '../regularization/regularization-form/regularization-form.component';
import Swal from 'sweetalert2';
import { LeaveFormComponent } from '../leave/leave-form/leave-form.component';
import { RosterFormComponent } from '../roster/roster-form/roster-form.component';
import { ColorPickerService, Cmyk } from 'ngx-color-picker';
import { assignee_role_name, datePickerMinDate } from '../../shared/constants';
import * as FileSaver from 'file-saver';
import { LeaveBalanceFormComponent } from '../leave/leave-balance-form/leave-balance-form.component';
declare const $: any;
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
	selector: 'app-attendance',
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './attendance.component.html',
	styleUrls: ['./attendance.component.scss']
})
export class AttendanceComponent implements AfterViewInit {
	assignee_role_name = assignee_role_name;
	getYears() {
		let yyyy = new Date().getFullYear();
		let yearList: any[] = [];
		for (let i = 0; i < 10; i++) {
			yearList.push({ value: yyyy, name: yyyy });
			yyyy -= 1;
		}
		return yearList;
	}
	yearList: any[] = this.getYears();
	monthList = [
		{ value: 0, name: "Jan" },
		{ value: 1, name: "Feb" },
		{ value: 2, name: "Mar" },
		{ value: 3, name: "Apr" },
		{ value: 4, name: "May" },
		{ value: 5, name: "Jun" },
		{ value: 6, name: "Jul" },
		{ value: 7, name: "Aug" },
		{ value: 8, name: "Sep" },
		{ value: 9, name: "Oct" },
		{ value: 10, name: "Nov" },
		{ value: 11, name: "Dec" },
	];
	days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
	isAll = false;
	minDate = datePickerMinDate;
	view: CalendarView = CalendarView.Month;
	CalendarView = CalendarView;
	viewDate: Date = new Date();
	refresh = new Subject<void>();

	events: CalendarEvent[] = [];
	allAttendance: any[] = [];
	selectedDate: Date | null = null;

	pageLoading = false;
	@ViewChild("calendarMonthViewComponent") calendarMonthViewComponent!: CalendarMonthViewComponent;
	@ViewChild("calendarWeekViewComponent") calendarWeekViewComponent!: CalendarWeekViewComponent;
	/* defaultColor = "#aaaaaa";
	defaultSecondaryColor = "#c1daff"; */
	weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	dayStartHour = 0;
	dayEndHour = 23;
	userList: any[] = [];
	allUserList: any[] = [];
	searchQuery: string = '';
	regularizationList: any[] = [];
	leaveList: any[] = [];
	disableDepartment = false;
	isAssignee = false;
	filters: any = {
		emp_code: null,
		department: null,
		department_roster: null,
		year: new Date().getFullYear(),
		month: new Date().getMonth()
	}
	hourSegmentsWeekView = 1;
	hourDurationWeekView = 60;
	hourSegmentHeightWeekView = 20;
	minimumEventHeightWeekView = 10;
	@ViewChild('calendarContainer') calendarContainer!: ElementRef;
	@ViewChild(RegularizationFormComponent) regForm!: RegularizationFormComponent;
	@ViewChild(LeaveFormComponent) leaveForm!: LeaveFormComponent;
	@ViewChild(RosterFormComponent) rosterForm!: RosterFormComponent;
	@ViewChild(LeaveBalanceFormComponent) leaveBalForm!: LeaveBalanceFormComponent;
	leave_balance: any = null;
	total_events: any = null;
	present_days: any = null;
	absent_days: any = null;
	working_hrs: any = null;
	colorUser: any = null;
	currentColor: any = null;
	colorLoader = false;
	public colorList = [
		{ key: "flame", value: "#e45a33", friendlyName: "Flame" },
		{ key: "orange", value: "#fa761e", friendlyName: "Orange" },
		{ key: "infrared", value: "#ef486e", friendlyName: "Infrared" },
		{ key: "male", value: "#4488ff", friendlyName: "Male Color" },
		{ key: "female", value: "#ff44aa", friendlyName: "Female Color" },
		{ key: "paleyellow", value: "#ffd165", friendlyName: "Pale Yellow" },
		{ key: "gargoylegas", value: "#fde84e", friendlyName: "Gargoyle Gas" },
		{ key: "androidgreen", value: "#9ac53e", friendlyName: "Android Green" },
		{ key: "carribeangreen", value: "#05d59e", friendlyName: "Carribean Green" },
		{ key: "bluejeans", value: "#5bbfea", friendlyName: "Blue Jeans" },
		{ key: "cyancornflower", value: "#1089b1", friendlyName: "Cyan Cornflower" },
		{ key: "warmblack", value: "#06394a", friendlyName: "Warm Black" },
	];
	public presetValues: string[] = [];
	fullDayMinTime = "07:00:00";
	halfDayMinTime = "05:10:00";

	constructor(private cpService: ColorPickerService, private apiService: ApiService, private toastr: ToastrService, private zone: NgZone, private cdRef: ChangeDetectorRef, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.presetValues = this.getColorValues();
	}

	ngAfterViewInit(): void {
		this.apiService.departmentList$.subscribe((departments: any[]) => {
			if (departments && departments.length) {
				if (departments.length === 1) {
					//If departments has only 1 entry then other are removed as user is Lead(with department) or Assignee
					this.disableDepartment = true;
					this.filters.department_roster = departments[0].id;
					this.filters.department = [departments[0].id];
				}
				this.apiService.userData$.subscribe((user: any) => {
					if (user) {
						if (/* !this.navbar.hasAttendanceAccess() &&  */user.role_name == this.assignee_role_name) {
							this.filters.emp_code = user.emp_code;
							this.isAssignee = true;
						}
						this.getRegularizationRequests();
						this.getLeaveRequests();
						this.apiService.userList$.subscribe((userList) => {
							if (userList) {
								this.allUserList = userList.filter((u) => u.emp_code);
								this.getUserList();
							}
						});
						this.refreshCalendar();
					}
				});
			}
		});
	}

	getRegularizationRequests() {
		if (this.navbar.hasRegularizationAccess()) {
			const payload: any = {};
			if (this.isAssignee && this.filters.emp_code) {
				payload["user"] = this.filters.emp_code;
			} else if (this.filters.department && this.filters.department.length) {
				payload["department"] = this.filters.department;
			}
			this.apiService.getRegularization(payload).subscribe({
				next: (data: any) => {
					this.regularizationList = data
					this.cdRef.detectChanges();
				}, error: (error) => {
					this.regularizationList = [];
				}
			});
		}
	}

	get filteredRegularizationList(): any[] {
		if (!this.searchQuery.trim()) {
			return this.regularizationList;
		}
		const q = this.searchQuery.toLowerCase().trim();
		return this.regularizationList.filter(item => {
			const fullName = `${item.emp_code?.first_name ?? ''} ${item.emp_code?.last_name ?? ''}`.toLowerCase();
			const inDate = (item.in_date ?? '').toLowerCase();
			const inTime = (item.in_time ?? '').toLowerCase();
			const outDate = (item.out_date ?? '').toLowerCase();
			const outTime = (item.out_time ?? '').toLowerCase();

			return fullName.includes(q) ||
				inDate.includes(q) ||
				inTime.includes(q) ||
				outDate.includes(q) ||
				outTime.includes(q);
		});
	}

	getLeaveRequests() {
		if (this.navbar.hasLeaveAccess()) {
			const payload: any = {};
			if (this.isAssignee && this.filters.emp_code) {
				payload["user"] = this.filters.emp_code;
			} else if (this.filters.department && this.filters.department.length) {
				payload["department"] = this.filters.department;
			}
			this.apiService.getLeave(payload).subscribe({
				next: (data: any) => {
					this.leaveList = data
					this.cdRef.detectChanges();
				}, error: (error) => {
					this.leaveList = [];
				}
			});
		}
	}

	// Filtered getter for Leave List
	get filteredLeaveList(): any[] {
		if (!this.searchQuery.trim()) {
			return this.leaveList;
		}
		const q = this.searchQuery.toLowerCase().trim();
		return this.leaveList.filter(item => {
			const fullName = `${item.emp_code?.first_name ?? ''} ${item.emp_code?.last_name ?? ''}`.toLowerCase();
			const storedFromDate = (item.from_date ?? '').toLowerCase();
			const storedToDate = (item.to_date ?? '').toLowerCase();

			return fullName.includes(q) ||
				storedFromDate.includes(q) ||
				storedToDate.includes(q);
		});
	}

	showApproveRegLoader: any = null;
	approveRegRequest(uId: any) {
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to approve request?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Approve',
			cancelButtonText: 'Cancel'
		}).then((result) => {
			if (result.value) {
				this.showApproveRegLoader = uId;
				this.apiService.approveRegularization({ id: uId, is_approved: true }).subscribe({
					next: () => {
						this.showApproveRegLoader = null;
						Swal.fire('Success', 'Regularization approved successfully.', 'success');
						this.refreshCalendar();
						this.getRegularizationRequests();
					}, error: (error) => {
						this.showApproveRegLoader = null;
						if (error.status == 401) { return }
						if (error.status == 404) {
							Swal.fire('Error', error.error, 'error');
						} else {
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					}
				});
			}
		})
	}

	showDeleteRegLoader: any = null;
	deleteConfirmReg(uId: any) {
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to delete record?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Delete',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.showDeleteRegLoader = uId;
				this.apiService.deleteRegularization(uId).subscribe({
					next: () => {
						this.showDeleteRegLoader = null;
						Swal.fire('Success', 'Deleted successfully.', 'success');
						this.refreshCalendar();
						this.getRegularizationRequests();
					}, error: (error) => {
						this.showDeleteRegLoader = null;
						if (error.status == 401) { return }
						if (error.status == 404) {
							Swal.fire('Error', error.error, 'error');
						} else {
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					}
				});
			}
		})
	}

	showApproveLeaveLoader: any = null;
	approveLeaveRequest(uId: any) {
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to approve leave request?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Approve',
			cancelButtonText: 'Cancel'
		}).then((result) => {
			if (result.value) {
				this.showApproveLeaveLoader = uId;
				this.apiService.approveLeave({ id: uId, is_approved: true }).subscribe({
					next: () => {
						this.showApproveLeaveLoader = null;
						Swal.fire('Success', 'Leave approved successfully.', 'success');
						this.refreshCalendar();
						this.getLeaveRequests();
					}, error: (error) => {
						this.showApproveLeaveLoader = null;
						if (error.status == 401) { return }
						if (error.status == 404) {
							Swal.fire('Error', error.error, 'error');
						} else {
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					}
				});
			}
		})
	}

	showDeleteLeaveLoader: any = null;
	deleteConfirmLeave(uId: any) {
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to delete record?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Delete',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.showDeleteLeaveLoader = uId;
				this.apiService.deleteLeave(uId).subscribe({
					next: () => {
						this.showDeleteLeaveLoader = null;
						Swal.fire('Success', 'Deleted successfully.', 'success');
						this.refreshCalendar();
						this.getLeaveRequests();
					}, error: (error) => {
						this.showDeleteLeaveLoader = null;
						if (error.status == 401) { return }
						if (error.status == 404) {
							Swal.fire('Error', error.error, 'error');
						} else {
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					}
				});
			}
		})
	}

	getUserList() {
		if (this.filters.department_roster) {
			this.userList = this.allUserList.filter((u) => u.department == this.filters.department_roster);
		} else {
			this.userList = this.allUserList.filter((u) => true);
		}
	}

	isToday(date: Date) {
		return isSameDay(new Date(), date);
	}

	get12HrTimeFromDateObject(date: Date) {
		let hours = date.getHours();
		const minutes = date.getMinutes().toString().padStart(2, '0');
		const ampm = hours >= 12 ? 'PM' : 'AM';
		hours = hours % 12;
		hours = hours ? hours : 12;
		const time12Hour = `${hours}:${minutes} ${ampm}`;
		return time12Hour;
	}

	setViewAllAttendance() {
		this.isAll = true;
		this.refreshCalendar();
	}

	setView(view: CalendarView) {
		this.isAll = false;
		this.view = view;
		this.refreshCalendar();
	}

	bubbleClick(e: any, event: any) {
		e.stopPropagation();
	}

	refreshCalendar() {
		this.cdRef.detectChanges();
		if (!this.isAll) {
			this.events = [];
			if (this.view == CalendarView.Month) {
				this.getAttendance();
			} else if (this.view == CalendarView.Week) {
				this.getRoster();
			}
		} else {
			this.getAllAttendance();
		}
	}

	getFromToDateForAll() {
		const filters: any = {};
		if (this.filters.year && this.filters.month !== null) {
			const refDate = new Date(this.filters.year, this.filters.month, 15);
			const from_date = startOfMonth(refDate);
			const to_date = lastDayOfMonth(refDate);
			filters["from_date"] = this.apiService.getDateStringFromDate(from_date, 'YYYY-MM-DD');
			filters["to_date"] = this.apiService.getDateStringFromDate(to_date, 'YYYY-MM-DD');
		}
		if (this.filters.department && this.filters.department.length) {
			filters["department"] = this.filters.department;
		}
		return filters;
	}

	getAllAttendance() {
		this.allAttendance = [];
		if (!this.filters.year || this.filters.month === null) {
			return;
		}
		let payload: any = this.getFromToDateForAll();
		this.pageLoading = true;
		this.cdRef.detectChanges();
		this.apiService.getAttendanceAll(payload, false).subscribe({
			next: (res: any) => {
				let len1 = res.data.length;
				for (let i = 0; i < len1; i++) {
					let len2 = res.data[i].attendance.length;
					if (!len2) {
						res.data[i].attendance = this.getDatesInRange(payload["from_date"], payload["to_date"]);
					}
					len2 = res.data[i].attendance.length;
					for (let j = 0; j < len2; j++) {
						res.data[i].attendance[j].dispDate = this.getDate(res.data[i].attendance[j].date);
						res.data[i].attendance[j].dispDay = this.getDay(res.data[i].attendance[j].date);
					}
				}
				this.allAttendance = res.data;
				this.pageLoading = false;
				this.cdRef.detectChanges();
			}, error: (error) => {
				this.allAttendance = [];
				this.pageLoading = false;
				this.cdRef.detectChanges();
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	getDatesInRange(startDateStr: string, endDateStr: string): any[] {
		const startDate = this.apiService.getDateFromDateString(startDateStr, "YYYY-MM-DD");
		const endDate = this.apiService.getDateFromDateString(endDateStr, "YYYY-MM-DD");
		const dates: any[] = [];
		let current = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
		while (current <= endDate) {
			dates.push({
				date: this.apiService.getDateStringFromDate(new Date(current), 'DD-MM-YYYY')
			});
			current.setDate(current.getDate() + 1);
		}
		return dates;
	}

	excelLoader = false;
	getAttendanceAllExcel() {
		if (!this.filters.year || this.filters.month === null) {
			return;
		}
		let payload: any = this.getFromToDateForAll();
		this.excelLoader = true;
		this.cdRef.detectChanges();
		this.apiService.getAttendanceAll(payload, true).subscribe({
			next: (res: any) => {
				let excelData: any = res.body;
				this.excelLoader = false;
				this.cdRef.detectChanges();
				let blob = new Blob([excelData], { type: "application/ms-excel" });
				let monthName = "";
				for (let i = 0; i < this.monthList.length; i++) {
					if (this.filters.month == this.monthList[i].value) {
						monthName = this.monthList[i].name;
					}
				}
				let fileName = "Attendance-" + monthName + this.filters.year + ".xlsx";
				FileSaver.saveAs(blob, fileName);
			}, error: (error) => {
				this.excelLoader = false;
				this.cdRef.detectChanges();
				if (error.status == 401) { return }
				this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	timesheetLoader = false;
	getTimesheetAllExcel() {
		if (!this.filters.year || this.filters.month === null) {
			return;
		}
		let payload: any = this.getFromToDateForAll();
		this.timesheetLoader = true;
		this.cdRef.detectChanges();
		this.apiService.getTimesheetAll(payload).subscribe({
			next: (res: any) => {
				let excelData: any = res.body;
				this.timesheetLoader = false;
				this.cdRef.detectChanges();
				let blob = new Blob([excelData], { type: "application/ms-excel" });
				let monthName = "";
				for (let i = 0; i < this.monthList.length; i++) {
					if (this.filters.month == this.monthList[i].value) {
						monthName = this.monthList[i].name;
					}
				}
				let fileName = "Timesheet-" + monthName + this.filters.year + ".xlsx";
				FileSaver.saveAs(blob, fileName);
			}, error: (error) => {
				this.timesheetLoader = false;
				this.cdRef.detectChanges();
				if (error.status == 401) { return }
				this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	getDate(dateStr: string) {
		try {
			let date = this.apiService.getDateFromDateString(dateStr, 'DD-MM-YYYY');
			return date.getDate();
		} catch (error) {
			return dateStr;
		}
	}

	getDay(dateStr: string) {
		try {
			let date = this.apiService.getDateFromDateString(dateStr, 'DD-MM-YYYY');
			return this.days[date.getDay()];
		} catch (error) {
			return dateStr;
		}
	}

	getClass(attnd: any) {
		let classes: string[] = ["data", "fw-bold"];
		if (attnd.status == "P" || attnd.status == "WFH") {
			if (attnd.work_time > this.fullDayMinTime) {
				classes.push("text-present");
			} else if (attnd.work_time >= this.halfDayMinTime) {
				classes.push("text-partial-present");
			} else {
				classes.push("text-half-present");
			}
		} else if (attnd.status == "P1/2") {
			classes.push("text-half-present");
		} else if (attnd.status == "A") {
			classes.push("text-absent");
		} else if (attnd.status == "WO") {
			classes.push("text-weekly-off");
		} else if (attnd.status == "H") {
			classes.push("text-holiday");
		}
		return classes.join(" ");
	}

	getFromToDate() {
		let payload: any = {}
		if (this.view == CalendarView.Month) {
			let days = this.calendarMonthViewComponent.view.days.filter((d) => d.inMonth);
			let from_date = days[0].date;/* this.calendarMonthViewComponent.view.period.start; */
			let to_date = days[days.length - 1].date;/* this.calendarMonthViewComponent.view.period.end */
			payload["from_date"] = moment(from_date).format('YYYY-MM-DD');
			payload["to_date"] = moment(to_date).format('YYYY-MM-DD');
		} else if (this.view == CalendarView.Week) {
			payload["from_date"] = moment(this.calendarWeekViewComponent.view.period.start).format('YYYY-MM-DD');
			payload["to_date"] = moment(this.calendarWeekViewComponent.view.period.end).format('YYYY-MM-DD');
		}
		return payload;
	}

	getAttendance() {
		setTimeout(() => {
			this.selectedDate = null;
			/* let payload: any = {
				emp_code: this.filters.emp_code,
				...this.getFromToDate()
			}
			if (!payload["emp_code"]) {
				return;
			} */
			let payload: any = {
				...this.getFromToDate()
			}
			this.pageLoading = true;
			this.cdRef.detectChanges();
			if (this.filters.emp_code) {
				payload["emp_code"] = this.filters.emp_code;
				this.apiService.getAttendance(payload).subscribe({
					next: (res: any) => {
						let data = res.res;
						this.leave_balance = res.leave_balance;
						this.total_events = res.total_events;
						this.present_days = res.present_days;
						this.absent_days = res.absent_days;
						this.working_hrs = res.working_hrs;
						let len = data.length;
						let events: CalendarEvent[] = [];
						for (let i = 0; i < len; i++) {
							if (data[i].date) {
								let start = moment(data[i].date, "DD-MM-YYYY").toDate();
								let end = moment(data[i].date, "DD-MM-YYYY").toDate();
								let e: CalendarEvent = {
									start: start,
									end: end,
									title: data[i].name,
									id: data[i].id
								}
								if (data[i].in_time) {
									start = moment(data[i].date + " " + data[i].in_time, "DD-MM-YYYY HH:mm").toDate();
									data[i].isInTime = true;
								} else {
									data[i].isInTime = false;
								}
								if (data[i].out_time) {
									end = moment(data[i].date + " " + data[i].out_time, "DD-MM-YYYY HH:mm").toDate();
									data[i].isOutTime = true;
								} else {
									data[i].isOutTime = false;
								}
								if (this.isEndLessThanStart(start, end)) {
									end = start;
								}
								e["start"] = start;
								e["end"] = end;
								e["meta"] = data[i];
								events.push(e);
							}
						}
						this.events = [...events];
						this.pageLoading = false;
						this.cdRef.detectChanges();
					}, error: (error) => {
						this.pageLoading = false;
						this.cdRef.detectChanges();
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
					}
				});
			} else {
				this.apiService.getLeaves(payload).subscribe({
					next: (res: any) => {
						let data = res;
						this.leave_balance = null;
						this.total_events = null;
						this.present_days = null;
						this.absent_days = null;
						this.working_hrs = null;
						let len = data.length;
						let events: CalendarEvent[] = [];
						for (let i = 0; i < len; i++) {
							if (data[i].date) {
								let start = moment(data[i].date, "DD/MM/YYYY").toDate();
								let end = moment(data[i].date, "DD/MM/YYYY").toDate();
								let e: CalendarEvent = {
									start: start,
									end: end,
									title: data[i].name,
									id: data[i].id
								}
								e["meta"] = data[i];
								events.push(e);
							}
						}
						this.events = [...events];
						this.pageLoading = false;
						this.cdRef.detectChanges();
					}, error: (error) => {
						this.pageLoading = false;
						this.cdRef.detectChanges();
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
					}
				});
			}
		}, 200);
	}

	rosterLegend: any[] = [];
	showPdfLegend = false;
	getRoster() {
		setTimeout(() => {
			this.selectedDate = null;
			let payload: any = {
				...this.getFromToDate()
			}
			if (this.navbar.hasRosterAccess()) {
				if (this.filters.department_roster) {
					payload["department"] = this.filters.department_roster;
				}
			} else {
				if (this.navbar.user?.department) {
					payload["department"] = this.navbar.user?.department;
				}
			}
			this.pageLoading = true;
			this.cdRef.detectChanges();
			this.apiService.getRoster(payload).subscribe({
				next: (res: any) => {
					let events: CalendarEvent[] = [];
					let len1 = res.length;
					for (let h = 0; h < len1; h++) {
						let len2 = res[h].line_items.length;
						let data = res[h].line_items.filter((l) => l.in_date && l.in_time && l.out_date && l.out_time);
						const full_name = res[h].emp_code.first_name + " " + res[h].emp_code.last_name;
						const userColor = res[h].emp_code.color || '#000000';
						for (let i = 0; i < len2; i++) {
							let start = moment(data[i].in_date + " " + data[i].in_time, "DD-MM-YYYY HH:mm").toDate();
							let end = moment(data[i].out_date + " " + data[i].out_time, "DD-MM-YYYY HH:mm").toDate();
							let e: CalendarEvent = {
								start: start,
								end: end,
								title: full_name,
								/* color: {
									primary: res[h].emp_code.color || this.defaultColor,
									secondary: this.defaultSecondaryColor,
								}, */
								color: {
									primary: userColor,
									secondary: this.hexToRgba(userColor, 0.2)
								},
								id: data[i].id
							}

							if (this.isEndLessThanStart(start, end)) {
								end = start;
							}
							e["start"] = start;
							e["end"] = end;
							e["meta"] = {
								emp_code: res[h].emp_code,
								timing: data[i],
								userInitial: this.getInitials(full_name),
								color: userColor
							};
							events.push(e);
						}
					}
					this.events = [...events];
					this.pageLoading = false;
					this.cdRef.detectChanges();
				}, error: (error) => {
					this.pageLoading = false;
					this.cdRef.detectChanges();
					if (error.status == 401) { return }
					this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				}
			});
		}, 200);
	}

	getEventHourCount(event: CalendarEvent): number {
		try {
			const start = new Date(event.start).getTime();
			const end = new Date(event.end || event.start).getTime();
			const diffMinutes = Math.round((end - start) / (1000 * 60));
			const minutesPerSegment = this.hourDurationWeekView / this.hourSegmentsWeekView;
			const segments = Math.max(1, Math.round(diffMinutes / minutesPerSegment));
			return segments;
		} catch (e) {
			return 1;
		}
	}

	getRepeatedBadges(event: CalendarEvent): { text: string; visible: boolean }[] {
		const start = new Date(event.start);
		const end = new Date(event.end || event.start);
		const count = this.getEventHourCount(event);
		const initial = event.meta?.userInitial || '';

		const items: any[] = [];
		for (let i = 0; i < count; i++) {
			let visible = true;
			// Hide first cell text if event starts at hh:30 and spans multiple segments
			if (i === 0 && start.getMinutes() > 0 && count > 1) {
				visible = false;
			}
			// Hide last cell text if event ends at hh:30 and spans multiple segments
			if (i === count - 1 && end.getMinutes() > 0 && count > 1) {
				visible = false;
			}
			items.push({ text: initial, visible });
		}
		return items;
	}

	exportLoader = false;
	exportToPDFOld(container: HTMLElement): void {
		if (!container) {
			this.toastr.error('Invalid element reference.', 'Error');
			return;
		}

		this.exportLoader = true;
		this.cdRef.detectChanges();

		setTimeout(async () => {
			try {
				// 1. Temporarily expand inner scroll containers
				const scrollableElements = container.querySelectorAll('.cal-time-events, .calendar-scroll-container');
				const originalStyles: { el: HTMLElement; overflow: string; height: string }[] = [];

				scrollableElements.forEach((el: Element) => {
					const htmlEl = el as HTMLElement;
					originalStyles.push({
						el: htmlEl,
						overflow: htmlEl.style.overflow,
						height: htmlEl.style.height
					});
					htmlEl.style.overflow = 'visible';
					htmlEl.style.height = 'auto';
				});

				// 2. Capture full expanded canvas
				const canvas = await html2canvas(container, {
					scale: 2,
					useCORS: true,
					scrollY: -window.scrollY,
					windowHeight: container.scrollHeight,
					height: container.scrollHeight,
					width: container.scrollWidth
				});

				// 3. Restore original container styles
				originalStyles.forEach(item => {
					item.el.style.overflow = item.overflow;
					item.el.style.height = item.height;
				});

				// 4. Generate Single-Page Scaled PDF
				const imgData = canvas.toDataURL('image/png');

				// Create landscape PDF with standard A4 width (297mm) and dynamic height to prevent canvas clipping
				const pdfWidth = 297;
				const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

				const pdf = new jsPDF('landscape', 'mm', [pdfWidth, pdfHeight]);
				pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

				pdf.save(`Roster_${moment(this.viewDate).format('YYYY-MM-DD')}.pdf`);

			} catch (err) {
				this.toastr.error('Failed to generate PDF.', 'Error');
			} finally {
				this.exportLoader = false;
				this.cdRef.detectChanges();
			}
		}, 100);
	}

	exportToPDF(container: HTMLElement): void {
		if (!container) {
			this.toastr.error('Invalid element reference.', 'Error');
			return;
		}

		// Populate legend ONLY with users who have events added on the calendar
		const uniqueEmpMap = new Map();
		this.events.forEach(event => {
			const emp_code = event.meta?.emp_code;
			if (emp_code && !uniqueEmpMap.has(emp_code)) {
				const fullName = event.title || '';
				const color = event.color?.primary || event.meta?.color || '#000000';
				uniqueEmpMap.set(emp_code, {
					name: fullName,
					color: color,
					initials: event.meta?.userInitial || this.getInitials(fullName)
				});
			}
		});
		const rawLegend = Array.from(uniqueEmpMap.values()) as any[];
		this.rosterLegend = rawLegend.filter((item, index, self) =>
			index === self.findIndex((t) => t.name === item.name)
		);

		this.showPdfLegend = true; // Show legend for PDF capture
		this.exportLoader = true;
		this.cdRef.detectChanges();

		const parentCol = container.parentElement as HTMLElement;
		const originalWidth = parentCol ? parentCol.style.width : '';
		const originalFlex = parentCol ? parentCol.style.flex : '';
		const originalMaxWidth = parentCol ? parentCol.style.maxWidth : '';

		// Save original container styles for padding & background
		const originalPadding = container.style.padding;
		const originalBackground = container.style.backgroundColor;

		if (parentCol) {
			parentCol.style.width = '100%';
			parentCol.style.flex = '0 0 100%';
			parentCol.style.maxWidth = '100%';
		}

		// Apply PDF padding and white background
		container.style.padding = '20px';
		container.style.backgroundColor = '#ffffff';

		// Temporarily hide current time markers inside the container
		const currentTimeMarkers = container.querySelectorAll('.cal-current-time-marker') as NodeListOf<HTMLElement>;
		const originalMarkerDisplays: string[] = [];
		currentTimeMarkers.forEach(marker => {
			originalMarkerDisplays.push(marker.style.display);
			marker.style.display = 'none';
		});

		setTimeout(async () => {
			try {
				const canvas = await html2canvas(container, {
					scale: 2,
					useCORS: true,
					windowWidth: container.scrollWidth,
					windowHeight: container.scrollHeight + 60
				});

				const imgData = canvas.toDataURL('image/png');
				const pdfWidth = 297; // Landscape A4 width in mm
				const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

				const pdf = new jsPDF('landscape', 'mm', [pdfWidth, pdfHeight]);
				pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

				const titleElement = container.querySelector('#weekViewTitleDoNotRemove');
				const dateRangeText = titleElement ? titleElement.textContent?.trim() : moment(this.viewDate).format('YYYY-MM-DD');
				pdf.save(`Roster_${dateRangeText}.pdf`);

			} catch (err) {
				this.toastr.error('Failed to generate PDF.', 'Error');
			} finally {
				this.showPdfLegend = false; // Hide legend after PDF capture

				// Restore current time markers
				currentTimeMarkers.forEach((marker, index) => {
					marker.style.display = originalMarkerDisplays[index];
				});

				// Restore original container padding and background
				container.style.padding = originalPadding;
				container.style.backgroundColor = originalBackground;

				if (parentCol) {
					parentCol.style.width = originalWidth;
					parentCol.style.flex = originalFlex;
					parentCol.style.maxWidth = originalMaxWidth;
				}

				this.exportLoader = false;
				this.cdRef.detectChanges();
			}
		}, 150);
	}

	isEndLessThanStart(start: Date, end: Date) {
		try {
			return end.getTime() < start.getTime();
		} catch (error) {
			return false;
		}
	}

	getDateFromDateString(date: any, time: any) {
		if (date == "" || date == null || date == undefined) {
			return null;
		}
		try {
			var dateArr = date.split("-");
			date = new Date(dateArr.reverse().join("/"));
			try {
				if (time) {
					let timeArr = time.split(":");
					date.setHours(timeArr[0]);
					date.setMinutes(timeArr[1]);
					date.setSeconds(timeArr[2]);
				}
			} catch (error) { }
		} catch (error) {
			date = null;
		}
		return date;
	}

	getInitials(fullName: any): string {
		if (!fullName) return '';
		const parts = fullName.trim().split(' ');
		if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
		return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
	}

	hexToRgba(hex: string, alpha: number): string {
		let c: any;
		if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
			c = hex.substring(1).split('');
			if (c.length === 3) {
				c = [c[0], c[0], c[1], c[1], c[2], c[2]];
			}
			c = '0x' + c.join('');
			return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},${alpha})`;
		}
		return 'rgba(0, 0, 0, 0.15)';
	}

	onLeaveListLength = 3;
	showListInPopup(lst: any[], date: Date) {
		let str = '<ul class="text-start"><li>' + lst.map((emp) => emp).join('</li><li>') + '</li></ul>';
		Swal.fire({
			title: "Leave on " + moment(date).format("DD-MMM-YYYY"),
			html: str
		})
	}

	isPresent(events: CalendarEvent[]) {
		try {
			if (events.length && this.isPresent1(events[0])) {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}

	isPresent1(event: CalendarEvent) {
		try {
			if (event.meta.isInTime /* && event.meta.isOutTime */) {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}

	isWeeklyOff(events: CalendarEvent[]) {
		try {
			if (events.length && this.isWeeklyOff1(events[0])) {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}

	isWeeklyOff1(event: CalendarEvent) {
		try {
			if (event.meta.weekly_off) {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}

	isWorkFromHome(events: CalendarEvent[]) {
		try {
			if (events.length && this.isWorkFromHome1(events[0])) {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}

	isWorkFromHome1(event: CalendarEvent) {
		try {
			if (event.meta.wfh) {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}

	isFuture(date: Date) {
		return isAfter(date, new Date());
	}

	getWorkingHrs(events: CalendarEvent[]) {
		try {
			if (events.length) {
				return events[0].meta.work_time;
			} else {
				return null;
			}
		} catch (error) {
			return null;
		}
	}

	getWorkingHrsColor(events: CalendarEvent[]) {
		try {
			if (events.length) {
				if (events[0].meta.work_time > this.fullDayMinTime) {
					return 'bg-full-working';
				} else if (events[0].meta.work_time >= this.halfDayMinTime) {
					return 'bg-partial-working';
				} else {
					return 'bg-half-working';
				}
			} else {
				return 'bg-half-working';
			}
		} catch (error) {
			return 'bg-half-working';
		}
	}

	isWorkingHrsFull(events: CalendarEvent[]) {
		try {
			if (events.length && this.isWorkingHrsFull1(events[0])) {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}

	isWorkingHrsFull1(event: CalendarEvent) {
		try {
			if (event.meta.work_time > "05:10:00") {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}

	isOnLeave(events: CalendarEvent[]) {
		try {
			return events.length && this.isOnLeave1(events[0]);
		} catch (error) {
			return false;
		}
	}

	isOnLeave1(event: CalendarEvent) {
		try {
			return event.meta.on_leave;
		} catch (error) {
			return false;
		}
	}

	isHoliday(events: CalendarEvent[]) {
		try {
			return events.length && this.isHoliday1(events[0]);
		} catch (error) {
			return false;
		}
	}

	isHoliday1(event: CalendarEvent) {
		try {
			return event.meta.holiday_details.is_holiday;
		} catch (error) {
			return false;
		}
	}

	getHolidayName(events: CalendarEvent[]) {
		try {
			if (events.length) {
				return events[0].meta.holiday_details.holiday_name;
			}
		} catch (error) { }
		return "";
	}

	getPendingTasksCount(events: CalendarEvent[]) {
		try {
			if (events.length) {
				return events[0].meta.task_id.length;
			} else {
				return null;
			}
		} catch (error) {
			return null;
		}
	}

	isTaskPending(events: CalendarEvent[]) {
		try {
			if (events.length && this.isTaskPending1(events[0])) {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}

	isTaskPending1(event: CalendarEvent) {
		try {
			if (event.meta.task_id.length > 0) {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}

	taskList: any = [];
	viewTasks(events: CalendarEvent[]) {
		this.taskList = [];
		if (events.length && events[0].meta.task_id.length) {
			this.pageLoading = true;
			this.apiService.getTasks({ id: events[0].meta.task_id }).subscribe({
				next: (data: any) => {
					this.pageLoading = false;
					this.taskList = data;
					this.cdRef.detectChanges();
					$("#viewTasksModal").modal("show");
				}, error: (error) => {
					this.pageLoading = false;
					this.cdRef.detectChanges();
					this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				}
			});
		} else {
			this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		}
	}

	getEventCount(events: CalendarEvent[]) {
		try {
			if (events.length) {
				return events[0].meta.event_details.event_name.length;
			} else {
				return null;
			}
		} catch (error) {
			return null;
		}
	}

	isHavingEvent(events: CalendarEvent[]) {
		try {
			if (events.length && this.isHavingEvent1(events[0])) {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}

	isHavingEvent1(event: CalendarEvent) {
		try {
			if (event.meta.event_details.event_name.length) {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}

	eventList: any = [];
	viewEvents(events: CalendarEvent[]) {
		this.eventList = [];
		if (events.length && events[0].meta.event_details.event_name.length) {
			this.eventList = events[0].meta.event_details.event_name;
			this.cdRef.detectChanges();
			$("#viewEventsModal").modal("show");
		} else {
			this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		}
	}

	getPresenterEventCount(events: CalendarEvent[]) {
		try {
			if (events.length) {
				return events[0].meta.presenter_event_details.event_name.length * 2;
			} else {
				return null;
			}
		} catch (error) {
			return null;
		}
	}

	isHavingPresenterEvent(events: CalendarEvent[]) {
		try {
			if (events.length && this.isHavingPresenterEvent1(events[0])) {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}

	isHavingPresenterEvent1(event: CalendarEvent) {
		try {
			if (event.meta.presenter_event_details.event_name.length) {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}

	presenter_eventList: any = [];
	viewPresenterEvents(events: CalendarEvent[]) {
		this.presenter_eventList = [];
		if (events.length && events[0].meta.presenter_event_details.event_name.length) {
			this.presenter_eventList = events[0].meta.presenter_event_details.event_name;
			this.cdRef.detectChanges();
			$("#viewPresenterEventsModal").modal("show");
		} else {
			this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		}
	}

	getDateString(date: Date) {
		try {
			return moment(date).format('DD-MM-YYYY')
		} catch (error) {
			return date;
		}
	}

	getTimeString(date: Date) {
		try {
			return moment(date).format('HH:mm')
		} catch (error) {
			return date;
		}
	}

	createReg(date: any) {
		this.regForm.initForm({
			emp_code: this.filters.emp_code,
			date: date,
			isAssignee: this.isAssignee
		});
	}

	editReg(obj: any) {
		this.regForm.initForm({ ...obj, isAssignee: this.isAssignee });
	}

	createLeave() {
		this.leaveForm.initForm({
			emp_code: this.filters.emp_code,
			isAssignee: this.isAssignee
		});
	}

	editLeave(obj: any) {
		this.leaveForm.initForm({ ...obj, isAssignee: this.isAssignee });
	}

	createRoster(emp_code: any) {
		this.rosterForm.initForm({
			emp_code: emp_code
		});
	}

	changeLeaveBal(emp_code: any, lb: any) {
		if (this.navbar.hasLeaveAccess()) {
			let obj: any = null;
			if (emp_code !== null && lb !== null) {
				obj = { emp_code: emp_code, lb: lb };
			}
			this.leaveBalForm.initForm(obj);
		} else {
			this.toastr.error("You don't have leave module access", 'No access', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		}
	}

	getNameFromTo(event: CalendarEvent) {
		try {
			let str = event.title + "\n(";
			str += event.meta.timing.in_date + " " + event.meta.timing.in_time || "-";
			str += " to ";
			str += event.meta.timing.out_date + " " + event.meta.timing.out_time || "-";
			str += ")";
			return str;
		} catch (error) {
			return event.title;
		}
	}

	getContrastingTextColor(hexColor) {
		try {
			/* Remove the hash symbol if present */
			hexColor = hexColor.replace(/^#/, '');

			/* Expand shorthand form (e.g., "03F") to full form (e.g., "0033FF") */
			if (hexColor.length === 3) {
				hexColor = hexColor.split('').map(char => char + char).join('');
			}

			/* Parse the r, g, b values */
			const r = parseInt(hexColor.substr(0, 2), 16);
			const g = parseInt(hexColor.substr(2, 2), 16);
			const b = parseInt(hexColor.substr(4, 2), 16);

			/* Calculate the brightness of the background color */
			const brightness = (r * 299 + g * 587 + b * 114) / 1000;

			/* Return black for light backgrounds, white for dark backgrounds */
			return brightness > 128 ? '#000000' : '#ffffff';
		} catch (error) {
			return '#000000';
		}
	}

	getColorValues() {
		return this.colorList.map(c => c.value);
	}

	openColorModal(user: any) {
		this.colorUser = user;
		this.currentColor = this.colorUser.color || "#000000";
		$("#colorModal").modal("show");
	}

	clearColorModal() {
		$("#colorModal").modal("hide");
	}

	onColorChange(e: any) { }

	saveColor() {
		if (!this.currentColor) {
			this.toastr.info("Please select color.", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let payload = {
			color: this.currentColor,
			emp_code: this.colorUser.emp_code
		}
		this.colorLoader = true;
		this.apiService.changeUserColor(payload).subscribe({
			next: data => {
				this.colorLoader = false;
				this.toastr.info("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.colorUser.color = this.currentColor;
				this.clearColorModal();
				this.cdRef.detectChanges();
				this.getRoster();
			}, error: (error) => {
				this.colorLoader = false;
				this.cdRef.detectChanges();
				let errorMsg = error.error;
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}
}